"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
var _player = require("@/api/player/player");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "200"
      }, {
        name: "组别名称",
        prop: "groupName",
        isShow: true,
        width: "200"
      }, {
        name: "开始时间",
        prop: "startTime",
        isShow: true,
        width: "200"
      }],
      funBtns: [],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "进入",
        class: "editor",
        option: "enter",
        span: 5
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      school: {
        bureauId: "",
        queryValue: "",
        type: 0
      },
      idList: [],
      checkBoxList: [],
      checkBoxs: [],
      matchName: ""
    };
  },
  methods: {
    // 获取选手进行的项目
    getPlayerStageList: function getPlayerStageList() {
      var _this = this;
      (0, _player.getPlayerMatchList)(_objectSpread({
        matchName: this.matchName
      }, this.page)).then(function (res) {
        var data = res.data;
        data.list.forEach(function (item) {
          if (item.type === 1) {
            item.type = "中职";
          } else if (item.type === 2) {
            item.type = "高职";
          } else if (item.type === 3) {
            item.type = "本科";
          }
        });
        _this.totalData = data.total;
        console.log(data.list);
        _this.listData = data.list;
      });
    },
    search: function search(val) {
      this.matchName = val.queryValue;
      this.getPlayerStageList();
    },
    // 进入
    enter: function enter(e) {
      this.$router.push({
        path: "/player/playerList",
        query: {
          groupId: e.groupId,
          matchId: e.matchId
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getPlayerStageList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getPlayerStageList();
    }
  },
  created: function created() {
    this.getPlayerStageList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};